var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: ['container', _vm._isMobile() ? 'mobile' : '']
  }, [_c('a-card', {
    attrs: {
      "bordered": false
    }
  }, [_vm.loading ? _c('a-skeleton') : _vm._e(), _c('a-list', {
    attrs: {
      "dataSource": _vm.dataSource,
      "pagination": _vm.pagination
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function fn(item) {
        return _c('a-list-item', {}, [_c('a-card', {
          staticClass: "item-card",
          on: {
            "click": function click($event) {
              return _vm.toDetail(item);
            }
          }
        }, [_c('a-row', {
          attrs: {
            "gutter": 24,
            "justify": "space-between"
          }
        }, [_c('a-col', {
          attrs: {
            "span": _vm._isMobile() ? 24 : _vm.isBigCover(item) ? 18 : 6
          }
        }, [_c('div', {
          staticClass: "img-zoom"
        }, [_c('img', {
          staticClass: "cover",
          attrs: {
            "src": item.eventCover_url,
            "alt": ""
          }
        })])]), _vm.isBigCover(item) ? _c('a-col', {
          staticClass: "item-desc",
          attrs: {
            "span": _vm._isMobile() ? 24 : 6
          }
        }, [_c('h2', [item.eventStatus == 0 ? _c('a-tag', [_vm._v("未开始")]) : _vm._e(), item.eventStatus == -1 ? _c('a-tag', [_vm._v("已结束")]) : _vm._e(), item.eventStatus == 1 || item.eventStatus == 2 ? _c('a-tag', {
          attrs: {
            "color": "green"
          }
        }, [_vm._v("进行中")]) : _vm._e(), _vm._v("\n                " + _vm._s(item.eventName))], 1), _c('h3', [_vm._v(_vm._s(_vm.getDictValue(item.eventCategory)))]), _c('br'), _c('p', [_vm._v("开始时间：" + _vm._s(item.eventBegin))]), _c('p', [_vm._v("到期时间：" + _vm._s(item.eventEnd))])]) : _c('a-col', {
          staticClass: "item-desc",
          attrs: {
            "span": _vm._isMobile() ? 24 : 18
          }
        }, [_c('div', [_c('h2', {
          staticStyle: {
            "display": "inline"
          }
        }, [item.eventStatus == 0 ? _c('a-tag', [_vm._v("未开始")]) : _vm._e(), item.eventStatus == -1 ? _c('a-tag', [_vm._v("已结束")]) : _vm._e(), item.eventStatus == 1 || item.eventStatus == 2 ? _c('a-tag', {
          attrs: {
            "color": "green"
          }
        }, [_vm._v("进行中")]) : _vm._e(), _vm._v("\n                " + _vm._s(item.eventName))], 1), _c('a-divider', {
          attrs: {
            "type": "vertical"
          }
        }), _c('a-icon', {
          attrs: {
            "type": "calendar",
            "theme": "twoTone"
          }
        }), _c('span', [_vm._v(" 活动时间：" + _vm._s(item.eventBegin) + " ~ " + _vm._s(item.eventEnd))])], 1), _c('br'), _c('div', {
          domProps: {
            "innerHTML": _vm._s(item.eventDesc)
          }
        })])], 1)], 1)], 1);
      }
    }])
  })], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };